import React from "react";
import { homeStyle } from '../utils/styles';
import { mePhoto } from '../components/images';

export function Home({ callback, language }) {


    const data = {
        en: {
            sayHello: "Hi I'm!",
            name: "Eric Joel",
            job: "Programmer that use web technology.",
            btnText: 'View my projects'
        },
        es: {
            sayHello: "Hola, soy",
            name: "Eric Joel",
            job: "Programador que utiliza tecnología web.",
            btnText: 'Ver mis proyectos'
        }
    }

      const dataAboutMe ={
        en:{
          title:'About Me', 
          title2:"Web developer specializing in front-end and notion on back-end development. Proficient in a range of technologies including HTML, CSS, JavaScript, React, React Native, Node.js, Firebase, SQL, and Tauri.js. Experienced in building responsive web and mobile applications with a focus on user-centered design, performance optimization, and seamless functionality. Known for delivering robust solutions that align with client goals and technical requirements, while maintaining scalability and best coding practices across projects.", 
          btnText:"Contact Me!", 
          btnText2:"Resume"
        }, 
     es:{
         title:"Sobre mí", 
         title2:"Desarrollador web especializado en front-end y nociones sobre desarrollo back-end. Competente en una variedad de tecnologías que incluyen HTML, CSS, JavaScript, React, React Native, Node.js, Firebase, SQL y Tauri.js. Experiencia en la creación de aplicaciones web y móviles responsivas con un enfoque en el diseño centrado en el usuario, la optimización del rendimiento y la funcionalidad perfecta. Conocido por ofrecer soluciones sólidas que se alinean con los objetivos y requisitos técnicos del cliente, al mismo tiempo que mantienen la escalabilidad y las mejores prácticas de codificación en todos los proyectos.", 
         btnText:"¡Contáctame!", 
         btnText2:"Currículum"  
        }
    } 

    return (

        <main >
            <section className={homeStyle.container}>
                <article className={homeStyle.article} >
                    <p className={homeStyle.title2}>{data[language]?.sayHello}</p>
                    <div className={homeStyle.titleContainer}>
                        <p className={homeStyle.title}>{data[language]?.name}</p>
                    </div>
                    <p className={homeStyle.title2}>{data[language]?.job}</p>
                    <span className={homeStyle.btn2} onClick={() => callback()}>
                        {/*  <FontAwesomeIcon icon={faEnvelope} className={homeStyle.btnIcon2} /> */}
                        <p className={homeStyle.btnText2}>{data[language]?.btnText}</p>
                    </span>
                </article>

                <article className={homeStyle.article2} >
                  <img src={mePhoto} alt='home' className={homeStyle.Img} />
                </article>
            </section>
            
            <section className={homeStyle.container2}>
                <p className={homeStyle.title3}>{dataAboutMe[language]?.title}</p>
                <p className={homeStyle.text}>{dataAboutMe[language]?.title2}</p>
            </section>
          
            




        </main>

    )
}